<template>
  <el-dialog title="补全手机号" :visible.sync="dialogVisible" width="350px" :close-on-click-modal='false'>
    <div class="phone-number">请将手机{{ phonenumber }}中间四位补全</div>
    <div class="verify-code-container" @click="focusInput">
      <!-- 1. 真实但隐藏的 Input (作为统一的数据接收和焦点管理源) -->
      {{ phonenumber.slice(0, 3) }}
      <input
        ref="hiddenInput"
        v-model="codeValue"
        type="tel"
        maxlength="4"
        class="hidden-input"
        autocomplete="off"
        @input="handleInput"
        @paste="handlePaste"
        @focus="onFocus"
        @keydown.backspace="handleBackspace"
        @blur="isFocused = false"
      />

      <!-- 2. 四个展示用的方框 -->
      <div
        v-for="(item, index) in 4"
        :key="index"
        class="code-box"
        :class="{ active: isActive(index) && isFocused }"
      >
        <!-- 显示对应的字符 -->
        <span v-if="codeValue[index]">{{ codeValue[index] }}</span>

        <!-- 3. 模拟闪烁的光标 (仅在激活且无内容时显示) -->
        <span
          v-if="
            isFocused &&
            ((!isCompleted && isActive(index) && !codeValue[index]) ||
              (isCompleted && index === 3))
          "
          class="cursor"
        ></span>
      </div>
      {{ phonenumber.slice(-4) }}
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="submitCodeValue">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class dialogComponent extends Vue {
  codeValue: any = '';
  dialogVisible = false;
  isFocused = false;
  isCompleted = false;
  phonenumber: any = '';
  formPhone: any = '';
  @Prop()
  phone!: string;
  /**
   * 点击容器时，聚焦到隐藏的真实输入框
   */
  focusInput(): void {
    const input = this.$refs.hiddenInput as HTMLInputElement;
    if (input) input.focus();
  }

  onFocus() {
    this.isFocused = true;

    // 如果之前已经输满了4位，此时重新获取焦点，保持完成状态
    // 如果没有输满，则重置完成状态（防止删减字符后状态错乱）
    if (this.codeValue.length !== 4) {
      this.isCompleted = false;
    }
  }
  submitCodeValue() {
    if (this.codeValue.length !== 4) return;
    const d = this.formPhone.replace(/\*{4}/g, this.codeValue);
    console.log('提交验证码', d);
    this.$emit('submit', d);
    this.closeDialog();
  }

  closeDialog() {
    this.codeValue = '';
    this.dialogVisible = false;
  }

  /**
   * 判断当前哪个框应该处于激活状态
   */
  isActive(index: number): boolean {
    // 如果没有任何输入，默认激活第一个框(索引为0)
    if (this.codeValue.length === 0) return index === 0;
    // 如果有输入，激活的框索引等于当前已输入的字符长度
    return this.codeValue.length === index;
  }

  openDialog() {
    this.phonenumber = JSON.parse(JSON.stringify(this.phone));
    this.formPhone = JSON.parse(JSON.stringify(this.phone));
    this.dialogVisible = true;

  }

  handleInput(): void {
    let val = this.codeValue.replace(/\D/g, '');
    if (val.length > 4) val = val.slice(0, 4);

    if (this.codeValue !== val) this.codeValue = val;

    if (val.length === 4) {
      // 🎯 输满4位时，标记为已完成，但不主动触发光标闪烁
      this.isCompleted = true;
      this.$emit('complete', val);

      // 确保焦点依然在隐藏的 input 上
      this.$nextTick(() => {
        const input = this.$refs.hiddenInput as HTMLInputElement;
        if (input) input.focus();
      });
    } else {
      // 如果长度小于4，说明用户删除了字符，取消完成状态
      this.isCompleted = false;
    }
  }

  /**
   * PC端专属优化：按下 Backspace 时的极速回退
   */
  handleBackspace(event: KeyboardEvent): void {
    // 如果当前框【有内容】，不拦截，让浏览器默认删掉该字符即可
    if (this.codeValue.length > 0) return;

    // 如果当前框【已经是空的】，阻止浏览器默认的页面后退行为
    event.preventDefault();
  }

  /**
   * 处理粘贴操作（支持从短信复制完整的4位验证码）
   */
  handlePaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pasteData = event.clipboardData?.getData('text') || '';
    // 提取纯数字，最多取4位
    const numbers = pasteData.replace(/\D/g, '').slice(0, 4);

    if (numbers.length > 0) {
      this.codeValue = numbers;
      // 粘贴完成后触发完成事件
      if (numbers.length === 4) {
        this.isCompleted = true;
        this.$emit('complete', numbers);
      }
    }
  }
}
</script>
<style scoped lang="scss">
.verify-code-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 300px; /* 可根据实际UI调整宽度 */
  height: 50px;
  position: relative;
  cursor: text;
}

.phone-number {
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0;
}

/* 核心：将真实的 input 完全透明并覆盖在四个 div 上方 */
.hidden-input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 10;
  outline: none;
  border: none;
  background: transparent;
  caret-color: transparent; /* 隐藏原生闪烁光标 */
}

/* 单个验证码方框样式 */
.code-box {
  width: 40px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative; /* 为了让绝对定位的光标能基于它定位 */
}

/* 激活状态的高亮边框 */
.code-box.active {
  border-color: #409eff;
  box-shadow: 0 0 5px rgba(64, 158, 255, 0.5);
}

/* --- 选中光标样式 --- */
.cursor {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 2px;
  height: 24px;
  background-color: #409eff;
  animation: blink 1s step-end infinite; /* 应用闪烁动画 */
}

// 闪烁关键帧动画
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
</style>
